import api from "../../ApiConfig";
import { Apis } from "../../../config";
import { NotificationManager } from "react-notifications";

const createCategoryList = async (data) => {
  try {
    let result = await api.post(Apis.CreateCategoryList, data);
    if (result.data.error) {
      NotificationManager.error(result.data.error);
      return null;
    }
    return result.data;
  } catch (error) {
    console.log(error);
    return null;
  }
};

const getCategoryList = async () => {
  try {
    let result = await api.get(Apis.GetAllCategoryList);
    if (result.data.error) {
      NotificationManager.error(result.data.error);
      return null;
    }
    return result.data;
  } catch (error) {
    console.log(error);
    return null;
  }
};

const getUpdateCategoryList = async (data) => {
  try {
    let result = await api.post(Apis.GetUpdateCategoryList, data);
    if (result.data.error) {
      NotificationManager.error(result.data.error);
      return null;
    }
    return result.data;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export default {
  createCategoryList,
  getCategoryList,
  getUpdateCategoryList,

};



// WEBPACK FOOTER //
// ./src/components/services/GetCategoryDetails/index.js